import { useEffect, useMemo, useState } from 'react';

const useInView = (ref) => {
	const [isIntersecting, setIntersecting] = useState(false);
	const [isFirstIntersect, setIsFirstIntersect] = useState(false);

	const observer = useMemo(() => new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting)), [ref]);

	useEffect(() => {
		observer.observe(ref.current);
		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		if (isIntersecting && !isFirstIntersect) setIsFirstIntersect(true);
	}, [isIntersecting]);

	return isFirstIntersect;
};

export default useInView;
